var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("textarea", {
    attrs: {
      cols: "40",
      rows: "10",
      disabled: _vm.disable,
      autocomplete: "no",
    },
    domProps: { value: _vm.value },
    on: { input: _vm.emitInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }